import React from 'react';
import { Button } from '../ui/button';

const StockErrorBanner = ({ stockError, onOverride, onDismiss }) => {
  if (!stockError) return null;
  return (
    <div className="bg-red-50 border-2 border-red-300 rounded-xl p-4" data-testid="stock-error-banner">
      <div className="flex items-start gap-3">
        <svg className="w-6 h-6 text-red-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" /></svg>
        <div className="flex-1">
          <h3 className="font-bold text-red-800 text-sm">Insufficient Stock</h3>
          <table className="mt-2 text-sm w-full">
            <thead>
              <tr className="text-left text-red-700">
                <th className="pr-4 pb-1">Design</th>
                <th className="pr-4 pb-1">Size</th>
                <th className="pr-4 pb-1">Color</th>
                <th className="pr-4 pb-1 text-right">Available</th>
                <th className="pr-4 pb-1 text-right">Requested</th>
                <th className="pb-1 text-right">Short</th>
              </tr>
            </thead>
            <tbody>
              {stockError.items.map((item, i) => (
                <tr key={i} className="text-red-900">
                  <td className="pr-4 py-0.5 font-semibold">{item.design_code}</td>
                  <td className="pr-4 py-0.5">{item.size}</td>
                  <td className="pr-4 py-0.5">{item.color}</td>
                  <td className="pr-4 py-0.5 text-right font-mono">{item.available}</td>
                  <td className="pr-4 py-0.5 text-right font-mono">{item.requested}</td>
                  <td className="py-0.5 text-right font-mono font-bold">{item.requested - item.available}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-3 flex items-center gap-2">
            {stockError.admin_override_available ? (
              <>
                <Button size="sm" variant="destructive" onClick={onOverride} data-testid="stock-force-override-btn">
                  Override & Save (Admin)
                </Button>
                <Button size="sm" variant="outline" onClick={onDismiss} data-testid="stock-error-dismiss-btn">Cancel</Button>
              </>
            ) : (
              <>
                <span className="text-red-700 text-xs font-medium">Please adjust quantities or contact admin for override.</span>
                <Button size="sm" variant="outline" onClick={onDismiss}>Dismiss</Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockErrorBanner;
